{
  "(optional)": "(isteğe bağlı)",
  "(required)": "(gerekli)"
}
